const NavLinks = {
  TEAM_ENTRY_MANAGEMENT: '/teamentry/management',
  TEAM_ENTRY_MANAGEMENT_BY_ID: '/teamentry/management',
  TEAM_ENTRY_MANAGEMENT_BY_ID_SELECTION: '/selection',
  TEAM_ENTRY_MANAGEMENT_BY_ID_HQ_SELECTION: '/hqselection',

  OU_ADMIN_MEET_INFO: '/meet/entry/team/oua/meetinfo',
  OME_LOADING: '/ome/loading'
};

export default NavLinks;